import React from 'react';

import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import { createFilterOptions } from '@material-ui/lab';

import useStyles from './styles';

const AutocompleteDropdown = ({ onChange, value, items, label, search }) => {
  const classes = useStyles();

  const [inputValue, setInputValue] = React.useState('');

  const filterOptions = createFilterOptions({
    stringify: option => option[search]
  });

  return (
    <Autocomplete
      classes={{ inputRoot: classes.inputRoot, input: classes.input }}
      value={items.length && (value || value === 0) ? items[value] : value}
      onChange={(event, newValue) => {
        onChange(newValue.value);
      }}
      inputValue={inputValue}
      onInputChange={(event, newInputValue) => {
        setInputValue(newInputValue);
      }}
      options={items}
      getOptionLabel={option => {
        if (!option) return '';
        return option[label];
      }}
      filterOptions={filterOptions}
      id="disable-clearable"
      disableClearable
      renderInput={params => (
        <TextField placeholder="Business Owner" {...params} />
      )}
    />
  );
};

export default AutocompleteDropdown;
